module.exports = __webpack_public_path__ + "static/media/calorie-deficit-first-lithonia-medical-center.23d125eb.jpg";